import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { 
  swiggyAPI, 
  CUISINE_API_URL, 
  CUISINE_SHOW_API_URL,
  POPULAR_RESTAURANT_API_URL,
  RESTAURANT_SHOW_API_URL
} from "../helpers/Constant";

const useRestaurantData = () => {
  const locDetails = useSelector((store) => store.location.locationDetails);
  const [latitude, setLatitude] = useState(locDetails[0]?.lat);
  const [longitude, setLongitude] = useState(locDetails[0]?.lng);
  const [city, setCity] = useState(locDetails[0]?.district);
  const [notServicable, setNotServicable] = useState(undefined);
  const [topicalBanner, setTopicalBanner] = useState([]);
  const [WOYM, setWOYM] = useState([]);
  const [sort, setSort] = useState([]);
  const [resList, setResList] = useState([]);
  const [topResList, setTopResList] = useState([]);
  const [filteredResList, setFilteredResList] = useState([]);
  const [appInstallLinks, setAppInstallLinks] = useState([]);
  const [footerCities, setFooterCities] = useState([]);
  const [bestPlaces, setBestPlaces] = useState([]);
  const [bestCuiNearMe, setBestCuiNearMe] = useState([]);
  const [expResNearMe, setExpResNearMe] = useState([]);
  const [popularRestaurants, setPopularRestaurants] = useState([]);
  const [cuisinePagination, setCuisinePagination] = useState(null);
  const [cuisineLoading, setCuisineLoading] = useState(false);
  const [popularRestaurantsPagination, setPopularRestaurantsPagination] = useState(null);
  const [popularRestaurantsLoading, setPopularRestaurantsLoading] = useState(false);
  const [restaurantDetails, setRestaurantDetails] = useState(null);
  const [restaurantLoading, setRestaurantLoading] = useState(false);
  const [restaurantError, setRestaurantError] = useState(null);

  // Fetch cuisines from new API
  const fetchCuisines = async (page = 1, perPage = 10) => {
    try {
      setCuisineLoading(true);
      console.log("Fetching cuisines from:", CUISINE_API_URL);
      
      const response = await fetch(CUISINE_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          page: page,
          per_page: perPage
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      console.log("Cuisines API Response:", result);
      
      // FIX: Check the correct response structure - data is inside result.data.data
      if (result.status === true && result.status_code === 200) {
        // The cuisine array is inside result.data.data
        const cuisinesData = result?.data?.data || [];
        console.log("Raw cuisines data:", cuisinesData);
        
        const formattedCuisines = cuisinesData.map(cuisine => ({
          id: cuisine.id,
          name: cuisine.name,
          image: cuisine.image,
          slug: cuisine.slug,
          description: cuisine.description || ""
        }));
        
        console.log("Formatted cuisines:", formattedCuisines);
        setWOYM(formattedCuisines);
        
        // Set pagination from result.data
        if (result.data) {
          setCuisinePagination({
            current_page: result.data.current_page,
            first_page_url: result.data.first_page_url,
            from: result.data.from,
            last_page: result.data.last_page,
            last_page_url: result.data.last_page_url,
            links: result.data.links,
            next_page_url: result.data.next_page_url,
            path: result.data.path,
            per_page: result.data.per_page,
            prev_page_url: result.data.prev_page_url,
            to: result.data.to,
            total: result.data.total
          });
        }
      } else {
        console.error("Unexpected API response structure:", result);
        setWOYM([]);
      }
    } catch (error) {
      console.error("Error fetching cuisines:", error);
      setWOYM([]);
    } finally {
      setCuisineLoading(false);
    }
  };

  // Fetch cuisine details with restaurants
  const fetchCuisineDetails = async (cuisineId) => {
    try {
      setCuisineLoading(true);
      console.log("Fetching cuisine details for ID:", cuisineId);
      
      const response = await fetch(CUISINE_SHOW_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: cuisineId
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      console.log("Cuisine Details API Response:", result);
      
      if (result.status === true && result.status_code === 200) {
        return {
          cuisine: result.data.cuisine,
          restaurants: result.data.restaurants
        };
      } else {
        console.error("Failed to fetch cuisine details:", result.message);
        return null;
      }
    } catch (error) {
      console.error("Error fetching cuisine details:", error);
      return null;
    } finally {
      setCuisineLoading(false);
    }
  };

  // Fetch popular restaurants from Jagods API
  const fetchPopularRestaurants = async (page = 1, perPage = 10) => {
    try {
      setPopularRestaurantsLoading(true);
      console.log("Fetching popular restaurants from:", POPULAR_RESTAURANT_API_URL);
      
      const response = await fetch(POPULAR_RESTAURANT_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          page: page,
          per_page: perPage
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      console.log("Popular Restaurants API Response:", result);
      
      if (result.status === true && result.status_code === 200 && result.data) {
        const restaurantsData = result.data.data || [];
        setPopularRestaurants(restaurantsData);
        setPopularRestaurantsPagination({
          current_page: result.data.current_page,
          first_page_url: result.data.first_page_url,
          from: result.data.from,
          last_page: result.data.last_page,
          last_page_url: result.data.last_page_url,
          links: result.data.links,
          next_page_url: result.data.next_page_url,
          path: result.data.path,
          per_page: result.data.per_page,
          prev_page_url: result.data.prev_page_url,
          to: result.data.to,
          total: result.data.total
        });
        console.log("Popular restaurants fetched:", restaurantsData.length);
      } else {
        console.error("Unexpected popular restaurants response:", result);
        setPopularRestaurants([]);
      }
    } catch (error) {
      console.error("Error fetching popular restaurants:", error);
      setPopularRestaurants([]);
    } finally {
      setPopularRestaurantsLoading(false);
    }
  };

  // Fetch restaurant details
  const fetchRestaurantDetails = async (restaurantId) => {
    try {
      setRestaurantLoading(true);
      setRestaurantError(null);
      console.log("Fetching restaurant details for ID:", restaurantId);
      
      const response = await fetch(RESTAURANT_SHOW_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: restaurantId
        })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      console.log("Restaurant Details API Response:", result);
      
      if (result.status === true && result.status_code === 200) {
        setRestaurantDetails(result.data);
        return result.data;
      } else {
        setRestaurantError(result.message || 'Failed to fetch restaurant details');
        return null;
      }
    } catch (error) {
      console.error("Error fetching restaurant details:", error);
      setRestaurantError(error.message);
      return null;
    } finally {
      setRestaurantLoading(false);
    }
  };

  // Load more popular restaurants
  const loadMorePopularRestaurants = async () => {
    if (popularRestaurantsPagination?.next_page_url) {
      const nextPage = popularRestaurantsPagination.current_page + 1;
      await fetchPopularRestaurants(nextPage, popularRestaurantsPagination.per_page);
    }
  };

  // Load previous popular restaurants
  const loadPreviousPopularRestaurants = async () => {
    if (popularRestaurantsPagination?.prev_page_url) {
      const prevPage = popularRestaurantsPagination.current_page - 1;
      await fetchPopularRestaurants(prevPage, popularRestaurantsPagination.per_page);
    }
  };

  // Go to specific page for popular restaurants
  const goToPopularRestaurantsPage = async (page) => {
    if (page >= 1 && page <= popularRestaurantsPagination?.last_page) {
      await fetchPopularRestaurants(page, popularRestaurantsPagination?.per_page || 10);
    }
  };

  async function getRestaurants(latitude, longitude) {
    try {
      setResList([]);
      console.log("Fetching restaurants for:", latitude, longitude);
      
      const data = await fetch(swiggyAPI(latitude, longitude));
      const json = await data.json();
      console.log("Restaurant API Response received");
      
      const notDeliverable = json?.data?.cards
        ?.map((x) => x?.card?.card)
        ?.find((x) => x?.["id"] === "swiggy_not_present");
      
      if (notDeliverable) {
        console.log("Location is not serviceable");
        setNotServicable(notDeliverable);
        return;
      }
      
      setNotServicable(undefined);
      
      const topResListData = json?.data?.cards
        ?.map((x) => x?.card?.card)
        ?.find((x) => x?.["id"] === "top_brands_for_you");
      
      const sortData = json?.data?.cards
        ?.map((x) => x?.card?.card)
        ?.find((x) => x?.sortConfigs);
      
      const resListData = json?.data?.cards
        ?.map((x) => x?.card?.card)
        ?.find((x) => x?.["id"] === "restaurant_grid_listing");
      
      const appInstallLinksData = json?.data?.cards
        ?.map((x) => x?.card?.card)
        ?.find((x) => x?.["id"] === "app_install_links");
      
      const footerCitiesData = json?.data?.cards
        ?.map((x) => x?.card?.card)
        ?.find((x) => x?.["id"] === "footer_content");
      
      const bestPlacesData = json?.data?.cards
        ?.map((x) => x?.card?.card)
        ?.find((x) => x?.["title"] === "Best Places to Eat Across Cities");
      
      const bestCuiNearMeData = json?.data?.cards
        ?.map((x) => x?.card?.card)
        ?.find((x) => x?.["title"] === "Best Cuisines Near Me");
      
      const expResNearMeData = json?.data?.cards
        ?.map((x) => x?.card?.card)
        ?.find((x) => x?.["title"] === "Explore Every Restaurants Near Me");

      if (topResListData?.gridElements?.infoWithStyle?.restaurants) {
        setTopResList(topResListData.gridElements.infoWithStyle.restaurants);
      }
      
      if (sortData?.sortConfigs) {
        setSort(sortData.sortConfigs);
      }
      
      if (resListData?.gridElements?.infoWithStyle?.restaurants) {
        const restaurants = resListData.gridElements.infoWithStyle.restaurants;
        setResList(restaurants);
        setFilteredResList(restaurants);
      }
      
      if (appInstallLinksData) setAppInstallLinks(appInstallLinksData);
      if (footerCitiesData?.cities) setFooterCities(footerCitiesData.cities);
      if (bestPlacesData?.brands) setBestPlaces(bestPlacesData.brands);
      if (bestCuiNearMeData?.brands) setBestCuiNearMe(bestCuiNearMeData.brands);
      if (expResNearMeData?.brands) setExpResNearMe(expResNearMeData.brands);
      
    } catch (err) {
      console.log("Error fetching restaurants: ", err);
      setNotServicable(undefined);
    }
  }
  
  useEffect(() => {
    if (locDetails && locDetails[0] && locDetails[0].lat && locDetails[0].lng) {
      const newLatitude = locDetails[0].lat;
      const newCity = locDetails[0].district;
      const newLongitude = locDetails[0].lng;
      setLatitude(newLatitude);
      setCity(newCity);
      setLongitude(newLongitude);
      
      getRestaurants(newLatitude, newLongitude);
      fetchCuisines(1, 10);
      fetchPopularRestaurants(1, 10);
    } else {
      console.log("Waiting for location details...");
      fetchCuisines(1, 10);
      fetchPopularRestaurants(1, 10);
    }
  }, [locDetails]);

  return [
    WOYM,
    topResList,
    sort,
    resList,
    filteredResList,
    setFilteredResList,
    appInstallLinks,
    footerCities,
    bestPlaces,
    bestCuiNearMe,
    expResNearMe,
    notServicable,
    popularRestaurants,
    fetchCuisines,
    fetchCuisineDetails,
    cuisinePagination,
    cuisineLoading,
    fetchPopularRestaurants,
    loadMorePopularRestaurants,
    loadPreviousPopularRestaurants,
    goToPopularRestaurantsPage,
    popularRestaurantsPagination,
    popularRestaurantsLoading,
    fetchRestaurantDetails,
    restaurantDetails,
    restaurantLoading,
    restaurantError
  ];
};

export default useRestaurantData;